import styled from "styled-components";

export const BandwidthOptionWrapper = styled.div`
  max-height: 24px;
  button {
    height: inherit;
  }
`;

export const DateTime = styled.td`
  font-weight: 400;
  color: var(--mode-text-neutral-weakest);
`;
